export default "__VITE_ASSET__CHjIBA1q__"